import Image from "next/image";
import cx from "classnames";

import WidgetFooter from "../WidgetFooter";
import WidgetHeader from "../WidgerHeader";
import { AmountInputWithCurrency, Select, PillBadge } from "../UI";

import {
  POPULAR_CONVERTER_PAIRS,
  DEFAULT_VALUE_PRECISION_LENGTH,
} from "../../constants/CryptoConverter";

import styles from "./CryptoConverter.module.scss";
import IconExchange from "./../../public/icon_exchange.svg";

const CryptoConverter = ({
  ctaClick,
  handleLeftAmountChange,
  handleRightAmountChange,
  handleLeftCurrencySelect,
  handleRightCurrencySelect,
  leftAmount,
  rightAmount,
  leftCurrency,
  rightCurrency,
  currenciesOptions,
  handlePopularPairClick,
  isCurrenciesLoading,
  isConversionRateFetching,
  popularPair,
}) => {
  return (
    <div className={styles.Container}>
      {/* The top header */}
      <WidgetHeader title={"Bitcoin & Crypto Converter"} ctaClick={ctaClick} />
      {/* Main content container starts */}
      <div className={cx(styles.Box)}>
        <div className={cx(styles.FromToInputContainer)}>
          <div className={cx(styles.FromInputs, styles.StandardItemMargin)}>
            <Select
              className={cx(styles.Select)}
              name="leftCurrencySelect"
              handleChange={handleLeftCurrencySelect}
              options={currenciesOptions}
              isGrouped={true}
              value={leftCurrency}
              isLoading={isCurrenciesLoading}
            />
            <AmountInputWithCurrency
              id="leftAmount"
              name="leftAmount"
              handleChange={handleLeftAmountChange}
              amount={leftAmount}
              currency={leftCurrency}
              isLoading={isConversionRateFetching}
              maxDecimalCharaters={DEFAULT_VALUE_PRECISION_LENGTH}
            />
          </div>
          <Image
            src={IconExchange}
            className={styles.IconExchange}
            alt="exchange"
          />
          <div className={cx(styles.ToInputs, styles.StandardItemMargin)}>
            <Select
              name="rightCurrencySelect"
              className={cx(styles.Select)}
              handleChange={handleRightCurrencySelect}
              options={{ crypto: currenciesOptions?.crypto }}
              isGrouped={true}
              value={rightCurrency}
              isLoading={isCurrenciesLoading}
            />
            <div className={cx(styles.TextBox)}>
              <AmountInputWithCurrency
                id="rightAmount"
                name="rightAmount"
                handleChange={handleRightAmountChange}
                amount={rightAmount}
                isLoading={isConversionRateFetching}
                currency={rightCurrency}
                maxDecimalCharaters={DEFAULT_VALUE_PRECISION_LENGTH}
              />
            </div>
          </div>
        </div>
        <div className={styles.PopularLabelContainer}>
          <div className={styles.PopularLabel}>Popular Pairs</div>
          <div className={styles.PopularLabelList}>
            {POPULAR_CONVERTER_PAIRS.map((pair, index) => (
              <PillBadge
                key={index}
                textContent={`${pair.from} to ${pair.to}`}
                value={`${pair.from}${pair.to}`.toLowerCase()}
                className={styles.SpacingRight}
                handleClick={() => handlePopularPairClick(pair)}
                selectedPillBadge={popularPair}
              />
            ))}
          </div>
        </div>
      </div>
      <WidgetFooter ctaClick={ctaClick} />
    </div>
  );
};

export default CryptoConverter;
